// search界面工具栏按钮模板
export const mainToolBarTemplate = {
  // 新增
  add: {
    Visible: true,
    Enable: false
  },
  // 查看
  see: {
    Visible: true,
    Enable: true
  },
  // 编辑
  update: {
    Visible: true,
    Enable: false
  },
  // 查询
  search: {
    Visible: true,
    Enable: true
  },
  // 导出
  exp: {
    Visible: true,
    Enable: true
  },
  // 打印
  print: {
    Visible: false,
    Enable: true
  },
  // 收藏
  Favor: {
    Visible: true,
    Enable: true
  },
  // 扩展功能
  more: {
    Visible: true,
    Enable: true
  },
  // 高级查找
  mysearch: {
    Visible: true,
    Enable: true
  }
}
// single界面工具栏按钮模板
export const singleToolBarTemplate = {
  // 保存按钮
  save: {
    Visible: true,
    Enable: false
  },
  // 编辑按钮
  edit: {
    Visible: true,
    Enable: true
  },
  // 删除按钮
  del: {
    Visible: true,
    Enable: false
  },
  // 锁定按钮
  lock: {
    Visible: true,
    Enable: false
  },
  // 解锁按钮
  unlock: {
    Visible: true,
    Enable: false
  },
  // 传递、传递反馈按钮
  notify: {
    Visible: true,
    Enable: true
  },
  // 打印按钮
  print: {
    Visible: false,
    Enable: true
  },
  // 重置按钮
  reset: {
    Visible: false,
    Enable: true
  },
  // 扩展功能按钮
  more: {
    Visible: true,
    Enable: true
  },
  // 附件按钮
  attachment: {
    Visible: true,
    Enable: true
  },
  // 审批按钮
  approve: {
    Visible: true,
    Enable: true
  },
  // 日志按钮
  log: {
    Visible: true,
    Enable: true
  },
  // 日志按钮
  freeReportPrint: {
    Visible: true,
    Enable: true
  },
  // 隐藏form
  hide: {
    Visible: false,
    Enable: true
  },
  // 返回按钮
  back: {
    Visible: true,
    Enable: true
  }
}
// 权限模板
export const authorityTemplate = {
  // 是否可查看
  see: true,
  // 查看本人、本部门、本公司、所有人
  seeType: 0,
  // 生效条件
  alEffectCondition: '保存',
  // 是否可编辑
  edit: false,
  // 特殊权限
  special: [{}],
  // 是否有查看金额权限
  showMoney: false,
  // 是否自动编码
  autoCode: true
}
